import { createExpense } from '#/graphql/mutations';
import type { CreateExpenseMutation, Expense } from '#/graphql/types';
import { useMutation, gql } from '@apollo/react-hooks';
import { get } from 'lodash';
import { useCallback } from 'react';
import { SubmitExpense } from '../utils/types';

const q = gql(createExpense);

const useExpenseCreate = () => {
  const [mutation, result] = useMutation<CreateExpenseMutation>(q);

  const createExpense = useCallback(
    async (expense: Expense) => {
      const { __typename, id, ...expenseInput } = expense;

      const response = await mutation({
        variables: {
          data: expenseInput,
        },
      });
      return get(response, 'data.createExpense', undefined);
    },
    [mutation],
  ) as SubmitExpense;

  return { createExpense, result };
};

export default useExpenseCreate;
